import React from 'react';
import Tooltip from '@fff-web/fff-ui-shared/Tooltip';
import { Info, Lock } from '@fff-web/fff-ui-shared/Icon';
import MysteryItem from './MisteryItem.png';
import {
  CFM_TITLE,
  CFM_SUBTITLE,
} from './chooseForMeTestIds';

import styles from './ChooseForMe.module.scss';

const ChooseForMe: React.FunctionComponent = () => (
  <div className={styles.cfmContainer}>
    <div className={styles.cfmImage}>
      <img src={MysteryItem} alt="" />
    </div>
    <div className={styles.cfmInfo}>
      <h3 data-testid={CFM_TITLE} className={styles.cfmTitle}>
        Choose For Me
        {' '}
        <Tooltip
          content="Annuals can customize the entire box, Seasonals can customize 4 products."
          placement="bottom"
        >
          <div className={styles.cfmInfoIconWrapper}>
            <Info />
          </div>
        </Tooltip>
      </h3>
      <h4 data-testid={CFM_SUBTITLE} className={styles.cfmSubtitle}>
        <Lock />
        {' '}
        Annual Only
      </h4>
    </div>
  </div>
);

export default ChooseForMe;
